import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import Modal from "../../components/utils/Modal";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import genericActions from "../../redux/generic/actions";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
import WIFIBatchDetails from "../../components/batchDetails/WIFIBatchDetails";

const { getACode } = genericActions;
const { getWiFiBatchReports, resetMessage } = reportActions;


const WIFIBatchReport = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { aCodeList } = useSelector(state => state.generic);
  const [searchItem, setSearchItem] = useState("");
  const today = new Date();
  const beforeTwoDays = new Date();
  beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const { wifiBatchReports, wifiBatchReportsLoading, wifiBatchReportsError, } = useSelector((state) => state.reports)
  const { defaultCurrency } = useSelector((state) => state.auth);
  const [selectedBatchId, setSelectedBatchId] = useState('');
  const [showBatchDetail, setShowBatchDetail] = useState(false);

// console.log("wifiBatchReports==>>",wifiBatchReports)

  const { register, handleSubmit, reset, getValues, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      distributorID: "",
      fromDate: formatDate(beforeTwoDays),
      toDate: formatDate(today),
      isReporttype: 1,
    },
  });

  useEffect(() => {
        dispatch(getACode());
        loadBatchReport({
            distributorID: "",
            batchID: "",
            fromDate: formatDate(beforeTwoDays),
            toDate: formatDate(today),
        });
    }, [dispatch]);

  
  const columns = [
   { displayName: "Batch Id", key: "BatchId" },
        { displayName: "Total Count", key: "TotalCount" },
        { displayName: "Success Count", key: "SuccessCount" },
        { displayName: "Failed Count", key: "FailedCount" },
        { displayName: "Pending Count", key: "PendingCount" },
        { displayName: "Created On", key: "CreatedOn" },
        { displayName: "Batch Status", key: "BatchStatus" },
        { displayName: "Wi Fi Type", key: "WifiType" },
         { displayName: "Action", key: "action" },

  ];

  const filteredItems = useMemo(() => {
    return Array.isArray(wifiBatchReports) && wifiBatchReports.length > 0
      ? wifiBatchReports.filter(item => {
        if (!searchItem) return true;
        return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
      })
      : [];
  }, [wifiBatchReports, searchItem]);

  const rowData = useMemo(() => {
    return (filteredItems || []).map((item) => ({
       BatchId: item?.BatchID,
            TotalCount: item?.TotalCount,
            SuccessCount: item?.SuccessCount,
            FailedCount: item?.FailedCount,
            PendingCount: item?.PendingCount,
            CreatedOn: item?.CreatedOn,
            BatchStatus: item?.BATCHSTATUS,
            WifiType: item?.WifiType,
             action: (
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleViewDetails(item)}
                >
                    <i className="ri-eye-line"></i>
                </button>
            )

    }));
  }, [filteredItems]);


  const onSubmit = (data) => {
    const payload = {
      ...data,
      distributorID: Number(data.distributorID || 0)
    }
    dispatch(getWiFiBatchReports(payload));
  };

      const handleViewDetails = (reqData) => {
        setSelectedBatchId(reqData?.BatchID);
        setShowBatchDetail(true);
    }

   const loadBatchReport = (formData) => {
        dispatch(getWiFiBatchReports({
            distributorID: Number(formData.distributorID || 0),
            batchID: formData.batchID || "",
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isBatchDetail: false,
        }))
    }


  const handleReset = () => {
    reset({
      distributorID: "",
      fromDate: formatDate(beforeTwoDays),
      toDate: formatDate(today),
    });
    dispatch(resetMessage());
  };

  console.log("filteredItems==>>", filteredItems)

  const handleExportExcel = () => {
    const data = filteredItems.map(item => ({
            "Batch Id": item["BatchId"],
            "Total Count": item["TotalCount"],
            "Success Count": item["SuccessCount"],
            "Failed Count": item["FailedCount"],
            "Pending Count": item["PendingCount"],
            "Created On": item["CreatedOn"],
            "Batch Status": item["BATCHSTATUS"],
            "Wi-Fi Type": item["WifiType"],

    }))

    downloadExcelSampleFile(data, "WIFI-Batch-report.xlsx");
  };


  return (
        <>

     {!showBatchDetail ? <CardLayout
      title="Wi-Fi Batch Report"
      icon="ri-file-chart-line "
      rightContent={
        <Button
          title="Excel"
          buttonType="button"
          variant="secondary"
          onClick={handleExportExcel}
          icon={<i className="ri-download-cloud-line me-2" />}
        />}
    >
      <div>
        {/* Body */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div
            className="row"

          >
            {/* ACode */}
            <div className="col-lg-2 col-md-4">
              <label className="form-label fw-semibold">ACode</label>
              <select
                className="form-select"
                {...register("distributorID")}
              >
                <option value="">Select ACode</option>

                {aCodeList?.map((item) => (
                  <option
                    key={item.Id}
                    value={item.Id}
                  >
                    {item.ACode}
                  </option>
                ))}
              </select>
            </div>
              
                {/* Batch ID */}
                            <div className="col-lg-3 col-md-4">
                                <label className="form-label fw-semibold">Batch ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Batch ID"
                                    {...register("batchID")}
                                />
                            </div>

            {/* From Date */}
            <div className="col-lg-2 col-md-4">
              <label className="form-label fw-semibold">From Date</label>
              <input
                type="date"
                className="form-control"
                {...register("fromDate")}
              />
            </div>

            {/* To Date */}
            <div className="col-lg-2 col-md-4">
              <label className="form-label fw-semibold">To Date</label>
              <input
                type="date"
                className="form-control"
                {...register("toDate")}
              />
            </div>

            <div className="col-lg-3 col-md-6 d-flex align-items-end gap-3" style={{ height: '70px' }}>
              {/* Buttons */}
              <Button
                title="Get Report"
                buttonType="submit"
                variant="primary"
                disable={wifiBatchReportsLoading}
                loading={wifiBatchReportsLoading}
                icon={<i className="ri-search-line me-2"></i>}
                style={wifiBatchReportsLoading ? { width: '46.5%', padding: '10px 2px' } : {}}
              />

              <Button
                title="Reset"
                buttonType="button"
                variant="secondary"
                onClick={handleReset}
                icon={<i className="ri-refresh-line me-2"></i>}
              />
            </div>

            <div className="col-lg-3 offset-lg-9 col-md-4 d-flex align-items-end" style={{ height: '70px' }}>
              <input
                type="search"
                onChange={(e) => setSearchItem(e.target.value)}
                className="form-control form-control-sm"
                placeholder="Search..."
              />
            </div>
          </div>
        </form>

        {/* Search Form end */}

      </div>
      {/* Table */}
      <div className="mt-2">
        <Table
          columns={columns}
          data={rowData}
          pagination
          loading={wifiBatchReportsLoading}
          tableHeight="270px"
        />

      </div>
   
    </CardLayout> :
       <WIFIBatchDetails
                    selectedBatchId={selectedBatchId}
                    onBack={() => {
                        setShowBatchDetail(false);
                        setSelectedBatchId("");
                        loadBatchReport(getValues());
                    }} />}
                      </>

  );
};

export default WIFIBatchReport;
